module.exports = __webpack_public_path__ + "toBride2-jp-w-w.2598ce6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-jp-w-w.jpg
// module id = WdNr
// module chunks = 0